exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.diy-video video{ display: block; width: 100%;\n}\n.cover-box{ position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 10;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/page/page/diy/model/Video.vue"],"names":[],"mappings":";AACA,kBAAkB,eAAe,CAAC,YAAY;CAC7C;AACD,YAAY,mBAAmB,CAAC,OAAO,CAAC,QAAQ,CAAC,YAAY,CAAC,aAAa,CAAC,YAAY;CACvF","file":"Video.vue","sourcesContent":["\n.diy-video video{ display: block; width: 100%;\n}\n.cover-box{ position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 10;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0443c12d","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/page/page/diy/model/Video.vue
// module id = NYpi
// module chunks = 0